import { render } from "./Private.vue?vue&type=template&id=5581bc9b&scoped=true&ts=true"
import script from "./Private.vue?vue&type=script&lang=ts"
export * from "./Private.vue?vue&type=script&lang=ts"

import "./Private.vue?vue&type=style&index=0&id=5581bc9b&scoped=true&lang=css"

import exportComponent from "/app/frontend-danahealth/dsg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5581bc9b"]])

export default __exports__